<template>
  <Transition name="toast">
    <div v-if="visible" class="toast-notification">
      <p class="toast-notification__text">{{ message }}</p>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

interface Props {
  message: string
  duration?: number
}

const props = withDefaults(defineProps<Props>(), {
  duration: 3000,
})

const visible = ref(false)

onMounted(() => {
  visible.value = true
  setTimeout(() => {
    visible.value = false
  }, props.duration)
})

defineExpose({
  hide: () => {
    visible.value = false
  },
})
</script>

<style scoped>
.toast-notification {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--color-white);
  color: var(--color-primary);
  padding: 1rem 2rem;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  min-width: 200px;
  text-align: center;
}

.toast-notification__text {
  font-family: Montserrat, Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0;
  color: var(--color-primary);
}

.toast-enter-active {
  transition: all 0.3s ease-out;
}

.toast-leave-active {
  transition: all 0.3s ease-in;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

@media (max-width: 48rem) {
  .toast-notification {
    bottom: 1.5rem;
    left: 1rem;
    right: 1rem;
    transform: none;
    min-width: auto;
  }

  .toast-enter-from,
  .toast-leave-to {
    transform: translateY(20px);
  }
}
</style>
